<template>
  <span v-if="collapsed" class="form-hint-disclosure">
    <span :id="hintId" class="sr-only">{{ text }}</span>
    <app-tooltip ref="tooltip" :content="text" variant="panel" :delay="0" interactive>
      <button type="button" class="form-hint-disclosure__button"
        :aria-label="label ? `${$t('forms.how_it_works')}: ${label}` : $t('forms.how_it_works')"
        :aria-describedby="hintId" @click.stop="tooltip.onEnter()">
        <span aria-hidden="true">?</span>
      </button>
    </app-tooltip>
  </span>
  <p v-else :id="hintId" class="form-field__hint">{{ text }}</p>
</template>

<script setup>
  import { computed, inject, ref, unref } from 'vue';
  import AppTooltip from '@/components/ui/feedback/AppTooltip.vue';
  import { getFormControlId } from '@/composables/useFormControlStyles';
  import { compactFormHintsKey } from '@/domain/formHints';

  const props = defineProps({
    text: { type: String, required: true },
    label: { type: String, default: '' },
    id: { type: String, default: '' },
  });
  const tooltip = ref(null);
  const compact = inject(compactFormHintsKey, false);
  const generatedId = getFormControlId('form-hint');
  const hintId = computed(() => props.id || generatedId);
  const collapsed = computed(() => unref(compact) && Boolean(props.text.trim()));
</script>

<style scoped>
  p.form-field__hint { flex-basis: 100%; }
  .form-hint-disclosure { display: inline-flex; align-items: center; }
  .form-hint-disclosure__button {
    @apply inline-flex shrink-0 items-center justify-center rounded-full border border-theme-border text-theme-text-secondary;
    width: 1.25rem;
    height: 1.25rem;
    font-size: 0.75rem;
    font-weight: 600;
    cursor: help;
  }
  .form-hint-disclosure__button:focus-visible {
    @apply outline-none border-theme-focus shadow-theme-focus;
  }
  @media (pointer: coarse) {
    .form-hint-disclosure__button { min-width: 2.75rem; min-height: 2.75rem; }
  }
</style>
